import { FEATURES } from "../config/features";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';


const Dashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [monetizationStatus, setMonetizationStatus] = useState(null);

  const handleGoToRecursos = () => {
    navigate("/recursos");
  };

  const handleGoToMonetizacion = () => {
    navigate("/monetizacion");
  };

  const handleGoToPerfilFuncional = () => {
    navigate("/perfil-funcional");
  };

  const wordcloudUrl = `http://localhost:8000/media/wordcloud_enfermedades.png?${Date.now()}`;

  useEffect(() => {
    const fetchMonetizationStatus = async () => {
      try {
        const res = await fetch("/api/monetizacion/status/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        });
        const result = await res.json();
        setMonetizationStatus(result.activated);
      } catch (err) {
        console.error("Error al obtener estado de monetización:", err);
      }
    };

    if (FEATURES.monetization) fetchMonetizationStatus();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 bg-white rounded-lg shadow-md text-center">
      <h2 className="text-3xl font-bold mb-4">{t("dashboard.title")}</h2>

      {FEATURES.monetization && monetizationStatus !== null && (
        <div
          className={`mb-6 px-4 py-2 rounded-lg font-medium text-white inline-block ${
            monetizationStatus ? "bg-green-500" : "bg-gray-500"
          }`}
        >
          {monetizationStatus
            ? t("dashboard.status_active")
            : t("dashboard.status_inactive")}
        </div>
      )}

      <p className="text-gray-700 mb-4">{t("dashboard.description")}</p>

      <div className="flex justify-center mt-6 mb-10">
        <img
          src={wordcloudUrl}
          alt={t("dashboard.wordcloud_alt")}
          className="w-full max-w-md md:max-w-lg lg:max-w-xl rounded-xl border border-gray-300 shadow-lg"
        />
      </div>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <button
          onClick={handleGoToRecursos}
          className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition"
        >
          📚 {t("dashboard.btn_resources")}
        </button>
        {FEATURES.monetization && (<button
          onClick={handleGoToMonetizacion}
          className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition"
        >
          💰 {t("dashboard.btn_monetize")}
        </button>)}
        <button
          onClick={handleGoToPerfilFuncional}
          className="bg-indigo-500 text-white px-6 py-3 rounded-lg hover:bg-indigo-600 transition"
          data-tooltip-id="tooltip-perfil"
          data-tooltip-content={t("dashboard.tooltip_profile")}
        >
          🧠 {t("dashboard.btn_profile")}
        </button>

      </div>
      <Tooltip
  id="tooltip-perfil"
  place="top"
  style={{
    backgroundColor: '#4F46E5',
    color: '#fff',
    borderRadius: '8px',
    padding: '10px',
    fontSize: '0.9rem',
    maxWidth: '220px',
    textAlign: 'center',
  }}
/>
    </div>
  );
};

export default Dashboard;
